export default __webpack_public_path__ + "static/media/dabbalanimal.db14dca1.png";